import {useSelector} from "react-redux";
import Cookies from 'js-cookie';
import useRequest from "hooks/useRequest";
import {useHistory} from "react-router";

const useLogin = () => {
    const request = useRequest();
    const history = useHistory();
    const loginUser = useSelector(state => state.login);

    const login = async ()=> {
        const res = await request.login();
        console.log(res.url)
        window.location.href = res.url;
    };

    const testlogin = async ()=> {
        const res = await request.testlogin();
        console.log(res.url)
        window.location.href = res.url;
    };

    const logout=()=> {
        Cookies.remove('tools.game.10antz');
        // window.location.href = LOGIN_URL;
        history.push('/login');
    };

    return {loginUser, login, logout, testlogin};
};

export default useLogin;
